import axios from 'axios';
import { navigateTo } from 'router/navigationService';
import { app } from 'router/routes';
import { toast } from 'react-toastify';
import toastConfig from './toast';
import secretStorage from './secretStorage';
import store from 'store/store';

// Create an instance of axios
const api = axios.create({
    'Content-Type': 'application/json; charset=UTF-8'
    // baseURL: process.env.REACT_APP_SERVER_PORT // Your API base URL
});

let requestInterceptor;

const setRolesInAxiosHeader = (roleIndex, schoolYear) => {

    if (requestInterceptor != undefined) {
        api.interceptors.request.eject(requestInterceptor);
    }

    requestInterceptor = api.interceptors.request.use(
        config => {
            // אנחנו מוודאים שלא דורסים פרמטרים קיימים
            // if (schoolYear) {
            //     if (config.params?.school_year == 'ALL') {
            //         delete config.params.school_year
            //         config.params = config.params
            //     }

            //     else config.params = {
            //         school_year: schoolYear,
            //         ...config.params,
            //     };
            // }

            // Retrieve the token from localStorage
            const user = secretStorage.getItem("user");
            const token = user?.token;
            if (token) {
                config.headers.Authorization = `Token ${token}`;
            }
            if (roleIndex || user?.default_user_roles)
                config.headers['X-User-Roles'] = roleIndex || user.default_user_roles;
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
};

setRolesInAxiosHeader()

// Add response interceptor
api.interceptors.response.use(
    response => response,
    error => {
        const isSSOUser = localStorage.getItem("sso_user") === "true"; // אפשר לשמור ב-login
        const redirectUrl = encodeURIComponent(process.env.REACT_APP_PORT);

        // Handle errors, e.g., redirect to login if unauthorized
        if (error.response)
            if (error.response && error.response.status === 403) {

                if (error.response.data.detail === "Authentication credentials were not provided.") {
                    toast.dismiss()
                    toast.error("שגיאת הרשאה", toastConfig)
                    store.dispatch({ type: "RESET_ALL_REDUCERS" })
                    secretStorage.clean()
                    if (isSSOUser)
                        window.location.href = `https://is.remote.education.gov.il/nidp/jsp/logoutSuccess.jsp?logoutURL=${redirectUrl}`;
                    else navigateTo(app.login);
                }
                else {
                    store.dispatch({ type: "RESET_ALL_REDUCERS" })
                    secretStorage.clean()
                    if (isSSOUser)
                        window.location.href = `https://is.remote.education.gov.il/nidp/jsp/logoutSuccess.jsp?logoutURL=${redirectUrl}`;
                    else navigateTo(app.login);
                }

                // Handle unauthorized errors here
                // Example: redirect to login page or clear local storage
            }
            else if (error.response.status === 502) {
                toast.error("שגיאת מערכת נסה שוב בעוד מספר שניות", toastConfig)

                // Handle unauthorized errors here
                // Example: redirect to login page or clear local storage
            }
        return Promise.reject(error);
    }
);

const requestAI = axios.create({
    baseURL: process.env.REACT_APP_AI_SERVER_PORT,
    headers: {
        "X-API-Key": "Go123TestTranscription_310_8779"
    }
})




export { requestAI, setRolesInAxiosHeader }

export default api;